/* eslint-disable */
import ss from '@/helpers/sessionStorage';
import store from '@/store';

const STATUS_PENDING = 2;

export default {
  checkIfCanRunAfterVerification() {
    const lastInstantCredit = ss.get('lastInstantCredit', null);
    const instantCredit = ss.get('instant_credit', null);
    if (instantCredit && lastInstantCredit === instantCredit) {
      return false;
    }

    return instantCredit !== null;
  },
  checkIfCanRunAfterLogin() {
    const checkIfCanRunAfterVerification = this.checkIfCanRunAfterVerification();
    const userData = store.state.user.userData;
    const verificationStatus = userData.verificationStatus;
    const idVerified = userData.idVerified;
    const isUserVerified =
      typeof idVerified !== 'undefined'
        ? idVerified || verificationStatus === STATUS_PENDING
        : true;
    return checkIfCanRunAfterVerification && isUserVerified;
  },
  run() {
    const code = ss.get('instant_credit', null);

    return store.dispatch('wallet/submitInstantCredit', code).then((data) => {
      ss.set('lastInstantCredit', code);
      return data;
    });
  },
  clear() {
    ss.del('lastInstantCredit');
    ss.del('instant_credit');
  },
};
